import React from 'react';
import { useNavigate, useParams } from 'react-router';
import { notification } from 'antd';

import { useAppDispatch, useAppSelector } from 'store';
import {
  ISupportMeasuresItem,
  TSupportMeasuresItemDraft,
} from 'store/slices/supportMeasures/interfaces';
import { MainLayout } from 'components/Layout/MainLayout';
import {
  loadSupportMeasuresItem,
  saveSupportMeasuresItem,
  saveSupportMeasuresItemAsDraft,
} from 'store/slices/supportMeasures/actions';
import { StatusesEnum } from 'constants/status';

import { SupportMeasuresForm } from './components/SupportMeasuresForm';
import { mapValuesToForm } from './components/formUtils';

export const Edit = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const { item } = useAppSelector(state => state.supportMeasures);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  React.useEffect(() => {
    dispatch(loadSupportMeasuresItem(id));
  }, []);

  const onFinish = (values: ISupportMeasuresItem) => {
    setIsLoading(true);
    dispatch(saveSupportMeasuresItem({ ...values, id: item.id }))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Сущность успешно изменена',
        });
        navigate('/supportMeasures');
      })
      .catch(() => setIsLoading(false));
  };

  const onSaveDraft = (values: TSupportMeasuresItemDraft) => {
    setIsLoading(true);
    dispatch(saveSupportMeasuresItemAsDraft({ ...values, id: item.id }))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Сущность успешно изменена',
        });
        navigate('/supportMeasures');
      })
      .catch(() => setIsLoading(false));
  };

  const cancelButtonHandler = () => {
    navigate('/supportMeasures');
  };

  return (
    <MainLayout pageTitle='Редактирование'>
      {item.id && item.id === Number(id) ? (
        <SupportMeasuresForm
          onFinish={onFinish}
          onSaveDraft={onSaveDraft}
          cancelButtonHandler={cancelButtonHandler}
          isDraft={item.status === StatusesEnum.DRAFT}
          isLoading={isLoading}
          initialValues={mapValuesToForm(item)}
        />
      ) : null}
    </MainLayout>
  );
};
